import React from "react";

function LoadMoreButton({ onClick, shown, total }) {
  if (total === 0) return null;

  return (
    <div className="listing-load-more">
      {shown < total && (
        <button type="button" onClick={onClick}>
          Carregar mais imóveis
        </button>
      )}
      <p className="listing-load-more__status">
        Exibindo {shown} de {total} imóveis
      </p>
    </div>
  );
}

export default LoadMoreButton;
